import React, { Component } from "react";
import { DKLabel, DKButton, DKIcons } from "deskera-ui-library";
import AutomationManager from "../AutomationManager";
import { AUTOMATION_ACTIONS, AUTOMATION_TRIGGERS } from "../AutomationConstants";

/*
PROPS:
- onClose
- onSelect(actionData)
*/

class AddActionPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
        trigger: AutomationManager.getAutomationTrigger()
    };
  }
  render() {
    return (
      <div className="transparent-background">
        <div
          className="popup-window p-v-s p-h-l"
          style={{ backgroundColor: "rgb(245, 245, 245)" }}
        >
          {this.renderHeader()}
          {this.renderAllActions()}
        </div>
      </div>
    );
  }

  renderHeader() {
    return (
      <div className="row justify-content-between pt-s pb-m">
        <DKLabel text="Add a New Action" className="fw-m fs-l" />
        <DKButton icon={DKIcons.ic_close} onClick={this.props.onClose} />
      </div>
    );
  }

  renderAllActions() {
    return (
      <div className="row justify-content-between flex-wrap">
        {this.getFilteredActions().map((action) => {
          return this.renderActionButton(action);
        })}
      </div>
    );
  }

  getFilteredActions() {
    let allowedActions = [];
    switch (this.state.trigger?.type) {
        case AUTOMATION_TRIGGERS.PEOPLE_DEAL_WON:
            allowedActions = [AUTOMATION_ACTIONS.SPLIT_WORKFLOW, AUTOMATION_ACTIONS.DESIGNATION, AUTOMATION_ACTIONS.CALCULATE_COMMISSION];
            break;
        case AUTOMATION_TRIGGERS.PEOPLE_INVOICE_CREATED:
            allowedActions = [AUTOMATION_ACTIONS.SPLIT_WORKFLOW, AUTOMATION_ACTIONS.DESIGNATION, AUTOMATION_ACTIONS.CALCULATE_COMMISSION, AUTOMATION_ACTIONS.INVOICE_COMMISSION];
            break;
        case AUTOMATION_TRIGGERS.PEOPLE_CANDIDATE_STAGE_CHANGED:
            allowedActions = [AUTOMATION_ACTIONS.SEND_EMAIL];
            break;
        case AUTOMATION_TRIGGERS.PEOPLE_LEAVE_CREATED:
          let isExistLeaveApproval= this.props.parentStep?.find(p=>p.type === AUTOMATION_ACTIONS.LEAVE_APPROVAL)
              if(!isExistLeaveApproval) {
                allowedActions = [AUTOMATION_ACTIONS.LEAVE_APPROVAL];
              }
              
              break;
        case AUTOMATION_TRIGGERS.EXPENSE_CREATED:
          let isExistExpenseApproval = this.props.parentStep?.find(p=>p.type === AUTOMATION_ACTIONS.EXPENSE_APPROVAL)

              if(!isExistExpenseApproval) {
                allowedActions = [AUTOMATION_ACTIONS.EXPENSE_APPROVAL];
              }
              break;
        case AUTOMATION_TRIGGERS.PEOPLE_DATE_ALERT:
            allowedActions = [AUTOMATION_ACTIONS.SEND_EMAIL];
            break;
        case AUTOMATION_TRIGGERS.PEOPLE_EMPLOYEE_ADDED:
            allowedActions = [AUTOMATION_ACTIONS.SEND_EMAIL];
            break;
        default:
            break;

    }

    allowedActions.push(AUTOMATION_ACTIONS.END_WORKFLOW);

    return AutomationManager.getAllActions().filter((action) => {
        return allowedActions.find((a) => a === action.type);
    });
  }

  renderActionButton(actionData) {
    return (
      <div
        className="row border-m bg-white border-radius-s shadow-s p-r mb-l cursor-hand unselectable"
        style={{ width: "48%" }}
        onClick={
          this.props.onSelect
            ? () => {
                this.props.onSelect(actionData);
              }
            : null
        }
      >
        {AutomationManager.getActionIcon(actionData.type)}
        <DKLabel text={actionData.title} className="ml-m" />
      </div>
    );
  }
}

export default AddActionPopup;
